import { render, staticRenderFns } from "./weeks.vue?vue&type=template&id=fbcd9272&scoped=true"
import script from "./weeks.vue?vue&type=script&lang=js"
export * from "./weeks.vue?vue&type=script&lang=js"
import style0 from "./weeks.vue?vue&type=style&index=0&id=fbcd9272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcd9272",
  null
  
)

export default component.exports